module.exports = {
  "var-grid-gap": "1rem",
  "var-grid-gap--wide": "1.5rem",
  "border-width-1": "1px",
  "border-width-2": "2px",
  "border-width-3": "4px",
  "border-radius-size-0": "0",
  "border-radius-size-1": "0.125rem",
  "border-radius-size-2": "0.25rem",
  "var-shadow-1": "0 4px 8px 0 rgba(100,102,106,0.1), 0 1px 4px 0 rgba(100,102,106,0.36)",
  "var-shadow-2": "0 4px 8px 0 rgba(100,102,106,0.15), 0 8px 16px 0 rgba(100,102,106,0.33)",
  "var-shadow-3": "0 32px 40px 0 rgba(100,102,106,0.33), 0 8px 16px 0 rgba(100,102,106,0.15)",
  "var-opacity-0": 0,
  "var-opacity-50": 0.5,
  "var-opacity-100": 1,
  "focus-ring-outline-offset": "4px",
  "focus-ring-outline": "2px solid #4B99E6",
  "focus-ring-box-shadow": "inset 0 0 0px 1px #005FB9",
  "colors": {
    "transparent": "rgba(255,255,255,0)",
    "green": "#008254",
    "green-light": "#40AD87",
    "green-lighter": "#81D6B8",
    "green-lightest": "#E3FAF2",
    "green-dark": "#006642",
    "nw-green": "#8ccb32",
    "blue": "#005FB9",
    "blue-light": "#4B99E6",
    "blue-lighter": "#9DCDFA",
    "blue-lightest": "#EEF7FF",
    "blue-dark": "#02427E",
    "red": "#DE2828",
    "red-light": "#FF5D5E",
    "red-lighter": "#FF9090",
    "red-lightest": "#FFE8E8",
    "red-dark": "#B40000",
    "yellow": "#FFC764",
    "yellow-light": "#FBD083",
    "yellow-lighter": "#FFE2AE",
    "yellow-lightest": "#FFF7EA",
    "yellow-dark": "#EFA92E",
    "white": "#ffffff",
    "neutral-darkest": "#000",
    "neutral-darker": "#64666A",
    "neutral-dark": "#8B8C8F",
    "neutral-light": "#B1B3B5",
    "neutral-lighter": "#D8D9DA",
    "neutral-lightest": "#F7F7F7",
    "teal": "#005FB9",
    "teal-light": "#EEF7FF"
  },
  "type": {
    "font-size-h1": "2rem",
    "font-size-h1--wide": "3.375rem",
    "font-size-h2": "1.5rem",
    "font-size-h2--wide": "2.25rem",
    "font-size-h3": "1.5rem",
    "font-size-h3--wide": "2.25rem",
    "font-size-h4": "1.25rem",
    "font-size-h4--wide": "1.5rem",
    "font-size-h5": "1.25rem",
    "font-size-h5--wide": "1.5rem",
    "font-size-body": "1rem",
    "font-size-small": "0.8125rem",
    "font-size-large-serif": "1.25rem",
    "font-size-large-serif--wide": "1.25rem",
    "font-size-body-serif": "1rem",
    "font-size-small-serif": "0.8125rem",
    "font-size-0--mobile": "0.75rem",
    "line-height-0--mobile": 1.3333333333333333,
    "font-size-0--desktop": "0.75rem",
    "line-height-0--desktop": 1.3333333333333333,
    "font-size-1--mobile": "0.8125rem",
    "line-height-1--mobile": 1.5384615384615385,
    "font-size-1--desktop": "0.8125rem",
    "line-height-1--desktop": 1.5384615384615385,
    "font-size-2--mobile": "1rem",
    "line-height-2--mobile": 1.5,
    "font-size-2--desktop": "1rem",
    "line-height-2--desktop": 1.5,
    "font-size-3--mobile": "1.25rem",
    "line-height-3--mobile": 1.3,
    "font-size-3--desktop": "1.5rem",
    "line-height-3--desktop": 1.3333333333333333,
    "font-size-4--mobile": "1.5rem",
    "line-height-4--mobile": 1.25,
    "font-size-4--desktop": "2.25rem",
    "line-height-4--desktop": 1.1666666666666667,
    "font-size-5--mobile": "2rem",
    "line-height-5--mobile": 1.1875,
    "font-size-5--desktop": "3.375rem",
    "line-height-5--desktop": 1.1111111111111112,
    "font-size-2-half--mobile": "1.125rem",
    "line-height-2-half--mobile": 1.3,
    "font-size-2-half--desktop": "1.25rem",
    "line-height-2-half--desktop": 1.3,
    "font-family-gotham": "Gotham, system-ui, sans-serif",
    "font-family-gotham-display": "GothamDisplay, system-ui, sans-serif",
    "font-family-chronicle": "\"Chronicle\", serif",
    "font-family-chronicle-display": "\"Chronicle Display\", serif"
  },
  "spacing": {
    "0": "0",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "1rem",
    "4": "1.75rem",
    "5": "2.75rem",
    "0--wide": "0",
    "1--wide": "0.25rem",
    "2--wide": "0.5rem",
    "3--wide": "1rem",
    "3-half": "1.5rem",
    "3-half--wide": "1.5rem",
    "4--wide": "2rem",
    "5--wide": "4rem"
  },
  "breakpoints": {
    "wide-size": "48rem",
    "wide": "(min-width: 48rem)",
    "not-wide": "(max-width: 47.99875rem)"
  }
};
